<template>
    <div class="page">
        <div class="mod-title">
            <span class="ico-wechat"></span>
            <span class="text">支付宝扫码支付</span>
        </div>
        <div class="mod-ct">
            <div class="top"></div>
            <div class="amount">￥{{ price }}</div>
            <div style="margin-top:10px;">推荐使用支付宝 可花呗支付<span style="padding-left: 6px; color: rgb(238, 67, 37);">有几率免单</span></div>
            <div class="qr-image">
                <img :src="imgUrl" alt="">
            </div>
            <div class="open_app">
                <div class="open-btn" @click="sumbit()">打开支付宝APP继续付款</div>
                <div class="btn-check" @click="toSure()">我已付款，返回查看订单</div>
            </div>
            <div class="detail-ct" v-if="isShow">
                <div class="dt">
                    <div>购买物品</div>
                    <div>小店订单-{{ orderNo }}</div>
                </div>
                <div class="dt">
                    <div>商户订单号</div>
                    <div>{{ orderNo }}</div>
                </div>
            </div>
            <div class="arrow" @click="changeShow">
                <i class="ico-arrow" v-if="!isShow"></i>
                <i class="ico-arrow1" v-if="isShow"></i>
            </div>
            <div class="tip">
                <div class="ico-scan"></div>
                <div class="tip-text">
                    <p>请使用支付宝扫一扫</p>
                    <p>扫描二维码完成支付</p>
                </div>
            </div>
        </div>
        <div class="guide" v-if="imgShow">
            <img src="@/assets/guide2.png" alt="">
            <div class="open-btn" @click="toSure()" style="margin-top:100px;border-radius: 20px;">支付完成</div>
        </div>
    </div>
</template>
<script>
import { wxRequest } from '@/api/user'
import { Toast, Dialog } from 'vant';
export default {
    data() {
        return {
            isShow: false,
            imgShow: false,  //指示图片显示

            payUrl: '',
            aliUrl: '',
            orderNo: '',
            price: '',
            imgUrl: '',
        }
    },
    created() {
        this.imgShow = false;
        if (this.$route.query.aliUrl) {
            this.imgUrl = this.$route.query.imgUrl;
            this.aliUrl = this.$route.query.aliUrl;
            window.location.href = "alipays://platformapi/startapp?saId=10000007&clientVersion=3.7.0.0718&qrcode=" + this.$route.query.aliUrl;
        } else {
            this.orderNo = this.$route.query.orderNo
            this.price = this.$route.query.price;
            wxRequest("sim/ali/ma/pay", { orderNo: this.orderNo }, "post").then((res) => {
                if (res.data.code == 200) {
                    this.imgUrl = "http://image.szxxtx.com:8888/" + res.data.data.img;
                    this.payUrl = res.data.data.url;
                    this.aliUrl = res.data.data.url;
                    var ua = window.navigator.userAgent.toLowerCase();
                    if(localStorage.getItem("htmlType")=='ali'||ua.match(/MicroMessenger/i) != 'micromessenger'){
                        window.location.href= this.payUrl;
                    }else{
                        this.$router.push({ path: '/user/aliMaPay', query: { aliUrl: this.payUrl, imgUrl: this.imgUrl } });
                    }
                } else {
                    Dialog.alert({ title: "提示", message: res.data.message });
                }
            })
        }
    },
    methods: {
        toSure() {
            wxRequest("sim/select/order/state", { orderNo: this.orderNo }, "post").then((res) => {
                if (res.data.code == 200) {
                    var iccid = localStorage.getItem('iccid');
                    if (iccid && iccid.length > 5) {
                        this.$router.replace('/newUser/home')
                    } else {
                        Dialog.alert({ title: "提示", message: '支付成功，请手动返回支付页面查询支付情况' });
                    }
                } else {
                    Dialog.alert({ title: "提示", message:'未查询到已支付订单，如已支付 请手动返回充值页面查询。' });
                }
            })
        },
        changeShow() {
            this.isShow = !this.isShow
        },
        sumbit() {
            var ua = window.navigator.userAgent.toLowerCase();
            if (ua.match(/MicroMessenger/i) == 'micromessenger') {
                //进入引导页
                this.imgShow = true;
                var timer = setInterval(() => {
                    clearInterval(timer)
                    this.$router.push({ path: '/user/aliMaPay', query: { aliUrl: this.payUrl, imgUrl: this.imgUrl } });
                }, 1000)
            } else {
                window.location.href = this.aliUrl;
            }
        }
    }
}
</script>
<style scoped lang="less">
.page {
    background: #f7f7f7;
    height: 100%;

    .mod-title {
        height: 60px;
        line-height: 60px;
        text-align: center;
        border-bottom: 1px solid #ddd;
        background: #fff;

        .ico-wechat {
            display: inline-block;
            width: 41px;
            height: 38px;
            background: url('~@/assets/alipay-pay.png') 0 -113px no-repeat;
            vertical-align: middle;
        }

        .text {
            font-size: 20px;
            color: #333;
            font-weight: normal;
            vertical-align: middle;
            margin-left: 6px;
        }
    }

    .mod-ct {
        margin-top: 15px;
        background: #fff url('~@/assets/wave.png') top center repeat-x;
        text-align: center;
        color: #333;

        .top {
            font-size: 20px;
            padding-top: 10px;
        }

        .amount {
            font-size: 48px;
            font-weight:bold;
            margin-top: 20px;
        }

        .qr-image {
            margin-top: 25px;

            img {
                width: 230px;
                height: 230px;
                margin: auto;
            }
        }
    }

    .open_app {
        margin-top: 30px;

       

        .btn-check {
            padding: 10px 20px;
            color: #328ce5;
            font-size: 14px;
            cursor: pointer;
            margin-top: 30px;
        }
    }
    .open-btn {
        border: 1px solid #328ce5;
        padding: 10px 20px;
        color: #fff;
        background: #328ce5;
        font-size: 14px;
        cursor: pointer;
        width: 200px;
        margin: auto;
    }

    .detail-ct {
        margin-top: 55px;
        padding: 0 19px;

        .dt {
            display: flex;
            justify-content: space-between;
            line-height: 28px;
            font-size: 14px;
        }
    }

    .arrow {
        padding: 6px 34px;
        border: 1px solid #e5e5e5;
        width: 22px;
        margin: auto;
        margin-top: 20px;

        .ico-arrow {
            display: inline-block;
            width: 20px;
            height: 11px;
            background: url('~@/assets/alipay-pay.png') -25px -100px no-repeat;
        }

        .ico-arrow1 {
            display: inline-block;
            width: 20px;
            height: 11px;
            background: url('~@/assets/alipay-pay.png') 0 -100px no-repeat;
        }
    }

    .tip {
        margin-top: 40px;
        border-top: 1px dashed #e5e5e5;
        padding: 30px 0;
        position: relative;

        .ico-scan {
            display: inline-block;
            width: 56px;
            height: 55px;
            background: url(~@/assets/alipay-pay.png) 0 0 no-repeat;
            vertical-align: middle;
        }

        .tip-text {
            display: inline-block;
            vertical-align: middle;
            text-align: left;
            margin-left: 23px;
            font-size: 16px;
            line-height: 28px;
        }
    }

    .guide {
        text-align: center;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 10;
        width: 100vw;
        height: 100vh;
        background: rgba(51, 51, 51, .92);

        img {
            width: 96%;
        }
    }
}
</style>